import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { StandingsTableHeader } from '../../../screens/components';
import { standingsCorrections } from '../../../constants.js';

import './genericStandingsTable.scss';

class CustomTable extends Component {

  getArraysLength(array = []) {
    return array.map(a => {
      return a.length;
    });
  }

  flattenArray(array) {
    const flaten = [];

    array.forEach(a =>{
      a.forEach(obj => {
        flaten.push(obj);
      });
    });

    return flaten;
  }

  renderHeader = (data, hasSubHeader) => {
    const header = data.header || [];
    let arraysLength;

    const classes = this.props.hasBorder ? 'generic-standings-table-header-cell border' : 'generic-standings-table-header-cell';

    if (hasSubHeader) {
      if (header && header.length > 1 && header[1]) {
        arraysLength = this.getArraysLength(header[1]);
      }

      return header.map((h, i) => {
        if (Array.isArray(h[0])) {
          const flattenArray = this.flattenArray(h);
          return (
            <tr key={`${i}trt`} className="header-row">
              {
                flattenArray.length && flattenArray.map((val, j) => {
                  const key = Object.keys(val)[0];
                  return <th key={`${j}ks`} className={classes}>{val[key]}</th>;
                })
              }
            </tr>
          );

        } else {
          return (
            <tr key={`${i}tr`} className="header-row">
              {
                h && h.map((subHeader, j) => {
                  return <th colSpan={arraysLength[j]} key={`${j}kk`} className={classes}>{subHeader}</th>;
                })
              }
            </tr>
          );
        }
      });
    } else {
      return (
        <tr className="header-row">
          {
            header[0] && header[0].map((subHeader, j) => {
              return <th key={`${j}kk`} className={classes}>{subHeader}</th>;
            })
          }
        </tr>
      );
    }
  }

  renderBody = (data, hasSubHeader) => {
    const header = data.header || [];
    const body = data.body || [];
    let newHeader = header[1];
    const classes = this.props.hasBorder ? 'generic-standings-table-body-cell border' : 'generic-standings-table-body-cell';

    if (header.length > 1 && Array.isArray(header[1][0])) {
      newHeader = this.flattenArray(header[1]);
    }


    return body.map((b, i) => {
      const className = b.className;
      const isAsteriskVisible = this.props.isAsteriskVisible;
      let penaltyPtsAsterisk = null;

      if (isAsteriskVisible && b.hasOwnProperty('penalty_pts') && b.penalty_pts !== '0') {
        penaltyPtsAsterisk = <i className="generic-standings-table-asterisk"> *</i>;
      }

      if (!hasSubHeader) {

        return <tr key={`${i}trb`}>
          {
            Object.keys(newHeader[0]).map((k, j) => {
              if (className && j === 0) {
                return <td className={`${classes} ${className}`} key={`${j}po`}>{b[k]}</td>;
              }
              if (b[k] && Boolean(b[k].match(/^https|http/))) {
                return (
                  <td className={classes} key={`${j}po`}>
                    <img className="generic-standings-table-image" src={b[k]} alt={b.teamName} />
                  </td>
                );
              }

              return <td className={classes} key={`${j}po`}>{b[k]}</td>;
            })
          }
        </tr>;
      } else {
        return <tr key={`${i}trb`}>
          { 
            newHeader.map((h, j) => {
              const key = Object.keys(h)[0];
              if (b[key] && Boolean(b[key].match(/^https|http/))) {
                return (
                  <td className={classes} key={`${j}po`}>
                    <img className="generic-standings-table-image" src={b[key]} alt={b.teamName} />
                  </td>
                );
              }

              if (b.className && j === 0) {
                return <td className={`${classes} ${className}`} key={`${j}po`}>{b[key]}</td>;
              }
              return <td className={classes} key={`${j}po`}>{b[key]}{key === 'teamName' && penaltyPtsAsterisk}</td>;
            })
          }
        </tr>;
      }
    });
  }

  renderFooter(data) {
    const footer = data.footer || [];

    const legends = footer.legend && footer.legend.map((f, i) => {
      const legendClass = f.colorId ?`legend-${f.colorId}` : '';

      return (
        <div key={`${i}ttr`}>
          <span className={`generic-standings-table-footer-color ${legendClass}`}></span>
          <span className="generic-standings-table-footer-title">{f.title}</span>
        </div>
      );
    });

    const penaltyPts = footer.penaltyPts && footer.penaltyPts.map((pts, i) => {
      const key = Object.keys(pts);

      return (
        <div key={`${i}ttr`}>
          {
            i===0 && <div className="generic-standings-table-penalty-title">(*) {standingsCorrections[footer.locale]}</div>
          }
          <span className="generic-standings-table-penalty-value">{key}: {pts[key]}</span>
        </div>
      );
    });

    const hasPenaltyPts = penaltyPts && penaltyPts.length > 0;

    return (
      <div className="generic-standings-table-footer-container">
        <div className={`generic-standings-table-legend-container ${!hasPenaltyPts ? 'full-width' : ''}`}>{legends}</div>
        {hasPenaltyPts && <div className="generic-standings-table-penalty-container">{penaltyPts}</div>}
      </div>
    );
  }

  render() {
    return (
      <div className={`generic-standings-table ${this.props.className || ''}`}>
        <StandingsTableHeader
          title={this.props.title}
          subtitle={this.props.subtitle}
          textAlign={Boolean(this.props.subtitle) ? 'left' : ''}
        />
        <table>
          <thead>{this.renderHeader(this.props.data, this.props.hasSubHeader)}</thead>
          <tbody className={this.props.firstConlumnTextAlign || ''} >{this.renderBody(this.props.data, this.props.hasSubHeader)}</tbody>
        </table>
        <div className="generic-standings-table-footer">{this.renderFooter(this.props.data)}</div>
      </div>
    );
  }
}


CustomTable.propTypes = {
  data: PropTypes.object,
  hasSubHeader: PropTypes.bool,
  hasBorder: PropTypes.bool,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  width: PropTypes.number,
  firstConlumnTextAlign: PropTypes.string,
  isAsteriskVisible: PropTypes.bool
};


export default CustomTable;



// WEBPACK FOOTER //
// ./src/screens/components/genericStandingsTable/GenericStandingsTable.jsx